import React from "react";

const Arrow = () => {
  return (
    <>
      <svg
        width="27"
        height="8"
        viewBox="0 0 27 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.0027 4.07133C26.198 3.87606 26.198 3.55948 26.0027 3.36422L22.8207 0.18224C22.6255 -0.0130227 22.3089 -0.0130227 22.1136 0.18224C21.9184 0.377502 21.9184 0.694084 22.1136 0.889346L24.9421 3.71777L22.1136 6.5462C21.9184 6.74146 21.9184 7.05805 22.1136 7.25331C22.3089 7.44857 22.6255 7.44857 22.8207 7.25331L26.0027 4.07133ZM0.976563 4.21777L25.6492 4.21777V3.21777L0.976562 3.21777L0.976563 4.21777Z"
          fill="#FCFFFE"
        />
      </svg>
    </>
  );
};

export default Arrow;
